import type { LucideIcon } from "lucide-react"
import {
  BriefcaseBusiness,
  CalendarClock,
  ChartColumn,
  Search,
  StickyNote,
  UserRound,
} from "lucide-react"

/** Assistant persona copy shared by the live chat shell. */
export const ASSISTANT = {
  name: "Robin",
  role: "Recruiting assistant",
} as const

export const LIVE_LOADING_STEP = "Loading conversation..."
export const LIVE_ERROR_TEXT =
  "Hmm - that didn't go through cleanly. Nothing's lost; send it again and I'll retry."

export const HERO_SUGGESTIONS: { text: string; icon: LucideIcon }[] = [
  { text: "Quick status on Herimino", icon: UserRound },
  { text: "Add a note to Alex Rivera that they prefer remote roles", icon: StickyNote },
  { text: "Catch me up on Jordan Vale", icon: ChartColumn },
  { text: "Add a note to Herimino that they prefer async updates", icon: CalendarClock },
  { text: "Open a req for a Senior Product Engineer", icon: BriefcaseBusiness },
  { text: "Find senior backend engineers near SF", icon: Search },
]
